import { ref } from 'vue';

const useFhSpecialTable = (params, url, callBack) => {
  // 分页信息
  const pagination = ref({
    current: 1,
    pageSize: 10,
    total: 0,
    foldedMaxPageBtn: 2,
    maxPageBtn: 4,
    showPageSize: true, // 是否显示数据条数选择器
    showJumper: true,
    size: 'small',
    pageSizeOptions: [10, 20, 50],
    showTotal: true // 是否显示数据总数
  });

  const dataList = ref([]); // 数据源

  // 分页操作
  const onPaginationEvent = async (page, pageSize) => {
    pagination.value.current = page;
    pagination.value.pageSize = pageSize;
    await getDataList();
  };

  // 获取数据信息
  const getDataList = async () => {
    // 验证 url 参数
    if (!url || typeof url !== 'function') {
      console.error('useFhSpecialTable: url 参数必须是一个函数', url);
      return;
    }

    const requestParams = {
      ...params,
      page: pagination.value.current,
      pageSize: pagination.value.pageSize
    };

    console.log('请求参数：', url, typeof url);

    const json = await url(requestParams);
    if (!json.error) {
      const result = json.result;
      const { records, total } = result;
      pagination.value = {
        ...pagination.value,
        current: result.current,
        total
      };
      dataList.value = records;
      if (callBack) {
        dataList.value = callBack(records);
      }
    }
  };

  return {
    pagination,
    onPaginationEvent,
    getDataList,
    dataList
  };
};

export default useFhSpecialTable;
